import { useState } from 'react';
import { FormContainer } from '../../../_core/form/form-container.component';
import { CreateLocationsNestedContainer } from './create-locations-form-nested.container';
import { ICloseableDialogProps } from '../../../_core/core.types';

export const CreateLocationsContainer = (props: ICloseableDialogProps) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Add Locations"
    >
      <CreateLocationsNestedContainer
        {...props}
        ignoreDefaults
        onError={(e) => setSubmitError(e ?? null)}
        onSuccess={(s) => setSuccess(s ?? null)}
      />
    </FormContainer>
  );
};
